export default __webpack_public_path__ + "static/media/slider-cai-1.007595a8.jpg";